import { TextArea } from "$components/inputs";
import React from "react";
import { useController } from "react-hook-form";

const RHFTextArea: FC<
  { name: string } & React.ComponentProps<typeof TextArea>
> = ({ name, ...restProps }): React.ReactElement => {
  const controller = useController({ name });

  return (
    <TextArea
      {...controller.field}
      error={controller.fieldState.error?.message}
      {...restProps}
    />
  );
};

export default RHFTextArea;
